/** @format */

import { type ChangeEvent } from 'react';

type ToggleProps = {
  id?: string;
  name?: string;
  checked?: boolean;
  label?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const Toggle = ({ id, name, checked = false, label = '', onChange = () => {} }: ToggleProps) => {
  return (
    <label className="custom-toggle" htmlFor={id}>
      <input id={id} type="checkbox" checked={checked} onChange={e => onChange(e)} name={name} />
      <span className="custom-toggle--switch" />
      <span>{label}</span>
    </label>
  );
};
